import { io } from "socket.io-client";
import { REACT_APP_CONSULTANT_SOCKET_URL, REACT_APP_COMMON_SOCKET } from "../../ytiruces";

let socket = null;
let commonSocket = null;

export const connectSocket = () => {
    if (socket?.connected) {
        return socket;
    }

    socket = io(REACT_APP_CONSULTANT_SOCKET_URL, {
        transports: ["websocket", "polling"],
        reconnection: true,
        reconnectionAttempts: Infinity,
        reconnectionDelay: 1000,
    });

    return socket;
};

export const connectCommonSocket = () => {
    if (commonSocket?.connected) {
        return commonSocket;
    }

    commonSocket = io(REACT_APP_COMMON_SOCKET, {
        transports: ["websocket", "polling"],
        reconnection: true,
        reconnectionAttempts: Infinity,
        reconnectionDelay: 1000,
    });

    return commonSocket;
};

export const getSocket = () => socket;

export const getCommonSocket = () => commonSocket;


export const disconnectCommonSocket = () => {
    if (socket) {
        commonSocket.disconnect();
        commonSocket = null;
    }
};

export const disconnectSocket = () => {
    if (socket) {
        socket.disconnect();
        socket = null;
    }
};